import React, { useEffect } from "react";
import {
  Button,
  ButtonToolbar,
  Card,
  Form,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import { useFormik } from "formik";
import {
  fetchBills,
  setTagAction,
  billsSelector,
  setCurrentPageAction,
  setOffsetAction,
  fetchBillSearchInterests,
  setBillSearchInterestsSuccess,
  setMyBillsSelected,
  setBillsOfInterestsSelected,
  setAllBillsSelected,
} from "../../_redux/billsSlice";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import CSS from "csstype";
import PerSiteFormatedMessage from "../../../Globals/components/PerSiteFormatedMessage";

interface BillSearchProps {
  intl?: any;
}

const filterBtnStyle: CSS.Properties = {
  background: "transparent",
  color: "#2B6D60",
  border: "1px solid #2B6D60",
  borderRadius: "2px",
  padding: "5px 10px",
};

const selectedFilterBtnStyle: CSS.Properties = {
  background: "#2B6D60",
  color: "#fff",
  border: "1px solid #2B6D60",
  borderRadius: "2px",
  padding: "5px 10px",
};

const BillSearch: React.FC<BillSearchProps> = ({ intl }: BillSearchProps) => {
  const dispatch = useDispatch();
  const {
    billSearchInterests,
    myBillsSelected,
    billsOfInterestsSelected,
    allBillsSelected,
  } = useSelector(billsSelector);

  useEffect(() => {
    dispatch(fetchBillSearchInterests());
  }, []);

  const searchForm = useFormik({
    initialValues: { searchText: "" },
    onSubmit(values) {
      dispatch(setCurrentPageAction(0));
      dispatch(setOffsetAction(0));
      dispatch(setTagAction(values.searchText));
      const selectedInterests = billSearchInterests.filter(
        (a) => a.selected === true
      );
      dispatch(
        fetchBills({
          tag: values.searchText,
          pageNumber: 0,
          categoryIds: selectedInterests?.length
            ? selectedInterests.map((a) => a.id.toString()).join(",")
            : "",
          getAll: allBillsSelected,
        })
      );
    },
  });

  const handleBillsOfInterestsSelected = async () => {
    const updatedInterests = await billSearchInterests.map((x) => {
      return { ...x, selected: false };
    });
    await dispatch(setMyBillsSelected(false));
    await dispatch(setAllBillsSelected(false));
    await dispatch(setBillsOfInterestsSelected(!billsOfInterestsSelected));
    await dispatch(setBillSearchInterestsSuccess(updatedInterests));

    if (billsOfInterestsSelected) {
      searchForm.handleSubmit();
    }
  };

  const handleUpdateInterests = async (interest) => {
    window.history.pushState(
      null,
      null,
      interest.name.split(",").shift().toLowerCase()
    );
    const updatedInterests = await billSearchInterests.map((x) =>
      x.id === interest.id
        ? { ...x, selected: !interest.selected }
        : { ...x, selected: false }
    );
    await dispatch(setBillSearchInterestsSuccess(updatedInterests));

    searchForm.handleSubmit();
  };

  const handleAllBillsSelected = async () => {
    await dispatch(setMyBillsSelected(false));
    await dispatch(setAllBillsSelected(!allBillsSelected));
    await dispatch(setBillsOfInterestsSelected(false));

    searchForm.handleSubmit();
  };
  return (
    <Card>
      <Card.Body>
        <Form onSubmit={searchForm.handleSubmit}>
          <Form.Group
            controlId="search-bills"
            className="mb-0 search-bills-form"
          >
            <div className="d-flex">
              <InputGroup className="mr-3" size="lg">
                <InputGroup.Prepend>
                  <InputGroup.Text
                    className="input-group-text pr-0 bg-transparent border-right-0"
                    defaultValue={searchForm.values.searchText}
                    onChange={searchForm.handleChange}
                  >
                    <i className="text-muted flaticon-search" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  onChange={searchForm.handleChange}
                  name={"searchText"}
                  placeholder={intl.formatMessage({
                    id: "BILL.SEARCH.PLACE_HOLDER",
                  })}
                  className="border-left-0"
                />
              </InputGroup>
              <Button
                variant="primary"
                as="input"
                type="submit"
                value={intl.formatMessage({ id: "COMMON.SEARCH_BUTTON" })}
                className="w-100px"
              />
            </div>

            {process.env.REACT_APP_SITE_TYPE !== "CODE" && (
              <div className="mt-4">
                <ButtonToolbar style={{ lineHeight: "3" }}>
                  {billSearchInterests &&
                    Array.isArray(billSearchInterests) &&
                    billSearchInterests.map((interest) => (
                      <span key={interest.id} className="pr-3">
                        <Button
                          size="sm"
                          className="font-weight-bold"
                          style={
                            interest.selected
                              ? selectedFilterBtnStyle
                              : filterBtnStyle
                          }
                          onClick={async () =>
                            await handleUpdateInterests(interest)
                          }
                        >
                          {interest.name}
                        </Button>
                      </span>
                    ))}
                </ButtonToolbar>
              </div>
            )}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default injectIntl(BillSearch);
